/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { Avatar, Button, Divider, List, Modal, Space, Typography, Input, message } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { formatDateTime } from '../utils/formatters';

const { Text } = Typography;
const { TextArea } = Input;

export default function CommentsModal({
  open,
  onCancel,
  viewingComments,
  comments,
  newComment,
  setNewComment,
  onAddComment,
  t,
}) {
  if (!viewingComments) return null;

  return (
    <Modal
      title={t('Comments - {{name}}', { name: viewingComments.clientName })}
      open={open}
      onCancel={onCancel}
      footer={[<Button key="close" onClick={onCancel}>{t('Close')}</Button>]}
      width={800}
    >
      <div style={{ marginBottom: 16 }}>
        <TextArea
          rows={3}
          placeholder={t('Add a new comment...')}
          value={newComment}
          onChange={(event) => setNewComment(event.target.value)}
          style={{ marginBottom: 8 }}
        />
        <Button
          type="primary"
          onClick={() => {
            if (!newComment.trim()) {
              message.warning(t('Please enter a comment'));
              return;
            }
            onAddComment(viewingComments.clientId, viewingComments.clientName, newComment);
            setNewComment('');
          }}
        >
          {t('Add Comment')}
        </Button>
      </div>
      <Divider />
      <List
        dataSource={[...comments].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))}
        renderItem={(comment) => (
          <List.Item>
            <List.Item.Meta
              avatar={<Avatar icon={<UserOutlined />} />}
              title={(
                <Space>
                  <strong>{comment.author}</strong>
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    {formatDateTime(comment.timestamp)}
                  </Text>
                </Space>
              )}
              description={comment.comment}
            />
          </List.Item>
        )}
      />
    </Modal>
  );
}
